import AirbrakeClient from 'airbrake-js';

const {
  REACT_APP_AIRBRAKE_PROJECT_ID,
  REACT_APP_AIRBRAKE_PROJECT_KEY,
  REACT_APP_AIRBRAKE_ENV,
} = global.pbgEnv;

const airbrake = new AirbrakeClient({
  projectId: REACT_APP_AIRBRAKE_PROJECT_ID,
  projectKey: REACT_APP_AIRBRAKE_PROJECT_KEY,
});

airbrake.addFilter((notice) => {
  notice.context.environment = REACT_APP_AIRBRAKE_ENV || 'development';
  return notice;
});


export const reportError = ({error, component, params}) => {
  const { auth, password, ...safeParams } = params;
  return airbrake.notify({
    error,
    context: {
      component,
    },
    params: safeParams,
  });
};



// WEBPACK FOOTER //
// ./src/lib/error-reporter.js